<template>
 <v-layout column>
    <v-layout>
      <top-info-panel >
        <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
            <h4>Mijn Profiel</h4>
            <p>Op deze pagina kunt u persoonlijke gegevens bekijken en instellingen aanpassen.</p>
        </v-flex>
      </top-info-panel>      
    </v-layout>
    <v-layout wrap px-3 align-center justify-center class="inset">      
      <v-flex xs12 md12 lg8 xl6 pt-2>          
          <v-widget title="Mijn profiel" class="" title-text-color="">                        
            <v-layout slot="widget-content">
               <v-flex xs12>     
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>     
                        <v-layout row wrap>
                            <v-flex xs12 mb-4>   
                        <!-- TABLET AND FULLSCREEN SIZE AVATAR HEADER -------------------------------------->                           
                                <v-flex v-if="useLarge" xs12 md8 d-flex column justify-start align-center>     
                                    <div>
                                        <div class="avatar-edit-button">
                                            <v-tooltip top>
                                                <template #activator="data">                                                                                                                                            
                                                    <v-btn fab depressed dark small color="accent" @click="uploadAvatarDialog=true" slot="activator">
                                                        <v-icon dark class="fas fa-pen"></v-icon>                                            
                                                    </v-btn>                                                                                
                                                </template>
                                                <span>Klik om een foto te uploaden</span>
                                            </v-tooltip>                                                                           
                                        </div>                  
                                        <dd-avatar :user="currentUser" :cacheValue="randomCacheValue"  size="extra-large"></dd-avatar>    
                                    </div>                                                                   
                                    <div>                                       
                                        <div>
                                            <h2>{{currentUser.person.firstName}} {{currentUser.person.lastName}}</h2>                                            
                                        </div>                                                                      
                                        <div>
                                            <label class="username">{{currentUser.email}}</label>
                                        </div>             
                                    </div>
                                </v-flex>   
                        <!--- PHONE SIZE  AVATAR HEADER ---------------------------------------------------------------------->                                
                                <v-flex v-if="!useLarge" xs12 md8 d-flex column justify-start align-center>      
                                    <div>
                                        <div class="avatar-edit-button-small">                                                                                                                                                                                  
                                            <v-btn fab depressed dark small color="accent" @click="uploadAvatarDialog=true" slot="activator">
                                                <v-icon dark class="fas fa-pen"></v-icon>                                            
                                            </v-btn>                                                                                                                                                                                                                  
                                            
                                        </div>
                                        <dd-avatar :user="currentUser"  size="large"></dd-avatar>    
                                    </div>
                                    <div>                                       
                                        <div>
                                            <h2 class="fullname-smaller">{{currentUser.person.firstName}} {{currentUser.person.lastName}}</h2>                                            
                                        </div>                                                                      
                                        <div>
                                            <label class="username-smaller">{{currentUser.email}}</label>
                                        </div>             
                                    </div>
                                </v-flex>                                                                                           
                            </v-flex>                              
                            <v-flex xs12 md6 px-2>                                                    
                                <v-text-field
                                v-model="selectedUser.firstName"                     
                                label="Voornaam"
                                required>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 px-2>                        
                                <v-text-field
                                v-model="selectedUser.lastName"                     
                                label="Achternaam"
                                required>
                                </v-text-field>     
                            </v-flex>
                            <v-flex xs12 md10 px-2>                    
                                <v-text-field
                                v-model="selectedUser.street"                     
                                label="Straat">
                                </v-text-field>      
                            </v-flex>
                            <v-flex xs12 md2 px-2>                            
                                <v-text-field
                                v-model="selectedUser.houseNumber"                     
                                label="Huisnummer">
                                </v-text-field>                                                                  
                            </v-flex>
                            <v-flex xs12 md2 px-2>                            
                                <v-text-field
                                v-model="selectedUser.zipcode"                     
                                label="Postcode">
                                </v-text-field>               
                            </v-flex>                                
                            <v-flex xs12 md10 px-2>                            
                                <v-text-field
                                v-model="selectedUser.city"                     
                                label="Plaats">
                                </v-text-field>               
                            </v-flex>        
                            <v-flex xs12 md6 px-2>                            
                                <v-text-field
                                v-model="selectedUser.phoneNumber"                     
                                label="Telefoonnummer">
                                </v-text-field>               
                            </v-flex>                                                                 
                            <v-flex row xs12>                  
                                <v-layout >                                                                                                      
                                    <v-spacer></v-spacer>                                         
                                    <v-btn                                                
                                        :disabled="!valid"
                                        color="success"
                                        @click="saveForm">
                                        Opslaan
                                    </v-btn>                        
                                </v-layout>                                                                    
                            </v-flex>  
                        </v-layout>                                     
                  </v-form>
                </v-flex>
            </v-layout>
          </v-widget>
      </v-flex>
    </v-layout>
<!-- DIALOG BOX FOR UPLOADING PHOTO --------------------------------------------------------------------------------------------->
    <v-dialog v-model="uploadAvatarDialog" v-if="uploadAvatarDialog" persistent max-width="600">     
        <v-flex>
            <v-layout column>
                
                <div class="avatar-button-container">
                    <div class="close-avatar-upload">
                        <v-btn fab depressed dark small color="accent" @click="closeUploadAvatar">
                            <v-icon dark class="fas fa-times"></v-icon>   
                        </v-btn>   
                    </div>
                </div>                                       
                <file-upload 
                    class="px-2"
                    :url="imageUploadUrl" 
                    @uploadDone="imageUploadingDone"
                    style="background-color:white; min-height:200px;"
                ></file-upload>                                                  
            </v-layout>
        </v-flex>                             
    </v-dialog>       
 </v-layout>
</template>
<script>

import { API_URL } from "../config.js"
import * as types from "../store/types"
import { mapGetters } from 'vuex'
import VWidget from "../components/global/VWidget"
import TopInfoPanel from '../components/global/TopInfoPanel'
import DdAvatar from "../components/global/DdAvatar"  
import FileUpload from "../components/form/FileUpload"

export default {
    data() {
        return {           
            randomCacheValue:0, 
            uploadAvatarDialog:false,
            valid: true,
            selectedUser:{},
            form:{
                rules:{
                    email:(value) =>{
                        // only validate on save not during typing
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || "ongeldig email adres"                        
                    }
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            currentUser: types.CURRENT_USER,            
        }),
        name() {
            return this.data 
        }, 
        useLarge(){
            switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return false
                    case 'sm': return false
                    case 'md': return true
                    case 'lg': return true
                    case 'xl': return true
                }
        },
        imageUploadUrl(){
            return `${API_URL}/users/${this.currentUser.id}/avatar`
        }        
    },
    methods: {
        closeUploadAvatar(){
            this.uploadAvatarDialog=false
        },
        saveForm() {
            this.$store.dispatch(types.SAVE_USER, {data:this.selectedUser} ).then((res) => {                                                               
                this.reloadCurrentUser()
                this.$notify("Je Profiel is succesvol aangepast", {color:"green",duration:1000})
            })
        },    
        imageUploadingDone(file){
            this.reloadCurrentUser()
            this.closeUploadAvatar()
            this.$notify("Je avatar is succesvol aangepast", {color:"green",duration:1000})
        },
        reloadCurrentUser(){
            this.$store.dispatch(types.CURRENT_USER,{ params:{ include:"person,person.address,avatar,tenant"}}).then((res)=>{
                this.generateNewCacheValue()                
            })
        },
        setUser(user){
            this.selectedUser.id          = user.id
            this.selectedUser.email       = user.email
            this.selectedUser.firstName   = user.person.firstName
            this.selectedUser.lastName    = user.person.lastName
            this.selectedUser.phoneNumber = user.person.phoneNumber

            this.selectedUser.street      = user.person.address.street
            this.selectedUser.houseNumber = user.person.address.houseNumber
            this.selectedUser.zipcode     = user.person.address.zipcode
            this.selectedUser.city        = user.person.address.city                
        },
        generateNewCacheValue(){
            this.randomCacheValue = Math.floor((Math.random() * 10000) + 1);
        }
    },
    components:{
        VWidget,
        TopInfoPanel,
        DdAvatar,
        FileUpload
    },
    beforeMount(){        
        this.setUser(this.currentUser);
    }
}
</script>

<style scoped>
    .avatar-button-container{
        flex:1;
        width:100%;   
        display:flex;
        justify-content: flex-end; 
        margin-left:-34px;
    }

    .close-avatar-upload{
        display:flex;
        position: absolute;
        align-content: flex-end;
        align-items: flex-end;
        z-index: 150;
        margin-top:10px;
        margin-left:18px;
    }    
    .avatar-edit-button{
        display:flex;
        position: absolute;
        align-content: flex-end;
        align-items: flex-end;
        width:100%;
        margin-top:-10px;
        margin-left:74px;
    }
    .avatar-edit-button-small{
        display:flex;
        position: absolute;
        align-content: flex-end;
        align-items: flex-end;
        width:100%;
        margin-top:-20px;
        margin-left:44px;
    }    
    .avatar-image{
        display:flex;
        background-size:cover;
        background-position: center top;
    }
    .username{
        font-size: 20px;
        color:#959595;
    }

    .username-smaller{
        color:#959595;        
    }
    .fullname-smaller{
        font-size:28px;
    }
</style>
